export const DEFAULT_HERO_HEADLINE = "Browse our Mockup Collection";
export const IMAGE_ONLY_HERO_HEADLINE = "Only Image";

export const isImageOnlyHeroHeadline = (value) =>
  String(value || "").trim().toLowerCase() === IMAGE_ONLY_HERO_HEADLINE.toLowerCase();

export const DEFAULT_HERO_BODY =
  "Tired of generic-looking product mockups? Whether you're after something truly unique, unconventional, or simply beautiful — we've got you covered. Browse a curated collection of mockups crafted by talented artists, and bring your ideas to life with our easy-to-use Mockup Generator. Apply one or even dozens of your designs in just a few clicks. Bring your products to life with Mockee!";

export const DEFAULT_HERO_HEADLINE_COLOR = "#F0AB73";

export const DEFAULT_HERO_CONTENT = {
  headline: DEFAULT_HERO_HEADLINE,
  body: DEFAULT_HERO_BODY,
  headlineColor: DEFAULT_HERO_HEADLINE_COLOR,
  ctaLabel: "",
  ctaUrl: "",
};

export const HERO_LIMITS = {
  headline: 120,
  body: 800,
  ctaLabel: 40,
  ctaUrl: 500,
};

const HEX_COLOR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export const firstDefinedString = (...values) => {
  for (const value of values) {
    if (value == null) continue;
    return String(value);
  }
  return "";
};

export const normalizeHeroColor = (value, fallback = DEFAULT_HERO_HEADLINE_COLOR) => {
  const next = String(value || "").trim();
  return HEX_COLOR.test(next) ? next.toUpperCase() : fallback;
};

export const isValidHeroColor = (value) => HEX_COLOR.test(String(value || "").trim());

export const isInternalHeroPath = (value) => {
  const url = String(value || "").trim();
  return url.startsWith("/") && !url.startsWith("//") && !url.includes("://");
};

export const getInternalHeroPath = (value) => {
  const url = String(value || "").trim();
  if (isInternalHeroPath(url)) return url;
  try {
    const parsed = new URL(url);
    if (typeof window !== "undefined" && parsed.origin === window.location.origin) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}` || "/";
    }
  } catch {
    return null;
  }
  return null;
};

export const isValidHeroCtaUrl = (value) => {
  const url = String(value || "").trim();
  if (!url) return true;
  if (url.includes("\\") || /\s/.test(url)) return false;
  if (isInternalHeroPath(url)) return url.length > 1 || url === "/";
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const resolveHeroContent = (settings = {}, fallback = DEFAULT_HERO_CONTENT) => {
  const headline = firstDefinedString(
    settings.heroHeadline,
    fallback.headline,
    DEFAULT_HERO_HEADLINE
  ).trim();
  const body = firstDefinedString(
    settings.heroBody,
    fallback.body,
    DEFAULT_HERO_BODY
  );
  const headlineColor = normalizeHeroColor(
    firstDefinedString(
      settings.heroHeadlineColor,
      fallback.headlineColor,
      DEFAULT_HERO_HEADLINE_COLOR
    )
  );
  const ctaLabel = firstDefinedString(
    settings.heroCtaLabel,
    fallback.ctaLabel
  ).trim();
  const ctaUrl = firstDefinedString(settings.heroCtaUrl, fallback.ctaUrl).trim();

  return {
    headline: headline || DEFAULT_HERO_HEADLINE,
    body,
    headlineColor,
    ctaLabel,
    ctaUrl,
  };
};
